/* eslint max-len:0 */
const Hungarian = {
    _language: 'magyar',
    _language_short: 'hu',
    agentWelkomMessage: 'Üdvözöljük. Tegye fel kérdését itt.',
    conversationTimestampHeaderFormat: 'HH:mm',
    couldNotConnect: 'Nem sikerült csatlakozni. Újrapróbálkozhat {retry}',
    couldNotConnectInner: 'próbálja újra most',
    couldNotConnectWithRetry: 'Nem sikerült csatlakozni. Folytatjuk az újrapróbálkozást, vagy {retry}.',
    couldNotConnectWithRetryInner: 'próbálja most',
    headerText: 'Hogyan segíthetünk?',
    imageClickToReload: 'Kattintson a kép újratöltéséhez.',
    imageClickToView: 'Kattintson a {size} kép megtekintéséhez.',
    imagePreviewNotAvailable: 'Előnézet nem elérhető.',
    inputPlaceholder: 'Írja be ide, majd nyomja meg az <enter>-t a küldéshez.',
    inputPlaceholderBlocked: 'Töltse ki a fenti űrlapot...',
    introAppText: 'Küldje el üzenetét alulról, vagy a kedvenc csatornáján keresztül.',
    introductionText: 'Tegye fel kérdését itt.',
    actionPaymentCompleted: 'Fizetés megtörtént.',
    actionPaymentError: 'Hiba történt a fizetés feldolgozása közben. <br> Kérjük, próbálja újra, vagy használjon másik kártyát.',
    actionPostbackError: 'Hiba történt a művelet feldolgozása közben. Kérjük, próbálja újra.',
    clickToRetry: 'Az üzenet nem lett kézbesítve. Kérjük, próbálja újra.',
    clickToRetryForm: 'Az űrlap nem lett benyújtva. Kattintson bárhova az űrlapon az újrapróbálkozáshoz.',
    connectNotificationText: 'Várja a választ, vagy válassza ki, melyik alkalmazásban szeretné folytatni.',
    connectNotificationSingleText: 'Várja a választ, vagy válassza ki, melyik alkalmazásban szeretné folytatni.',
    connectNotificationSingleButtonText: 'Kapcsolja be a <name> értesítéseket',
    connectNotificationOthersText: 'mások',
    emailChangeAddress: 'E-mail címem módosítása',
    emailDescription: 'Ha e-mailben szeretne értesítést kapni, amikor választ kap, adja meg az e-mail címét.',
    emailFieldLabel: 'Az ön e-mail címe',
    emailFieldPlaceholder: 'Az ön e-mail címe',
    emailFormButton: 'Tovább',
    fetchHistory: 'Töltse be a többit',
    fetchingHistory: 'Történet betöltése...',
    frontendEmailChannelDescription: 'Küldjön nekünk egy e-mailt, és amint lehetséges, válaszolunk.',
    invalidFileError: 'Csak képek támogatottak. Válasszon olyan fájlt, amelynek támogatott kiterjesztése van (jpg, jpeg, png, gif vagy bmp).',
    lineChannelDescription: 'Szkennelje be a QR kódot, hogy kapcsolatba léphessen velünk a LINE-on.',
    locationNotSupported: 'A böngészője nem támogatja a helymeghatározási szolgáltatásokat, vagy azok le vannak tiltva. Kérem, írja be a helyét.',
    locationSecurityRestriction: 'Ez a weboldal nem férhet hozzá a helyéhez. Kérem, írja be a helyét.',
    locationSendingFailed: 'Nem sikerült elküldeni a helyet',
    locationServicesDenied: 'Ez a weboldal nem férhet hozzá a helyéhez. Engedélyezze a hozzáférést a beállításokban, vagy írja be a helyét.',
    messageError: 'Hiba történt az üzenet küldése közben. Kérem, próbálja újra.',
    messageIndicatorTitlePlural: '({count}) új üzenet',
    messageIndicatorTitleSingular: '({count}) új üzenet',
    messageRelativeTimeDay: '{value} nappal ezelőtt',
    messageRelativeTimeHour: '{value} órával ezelőtt',
    messageRelativeTimeJustNow: 'Épp most',
    messageRelativeTimeMinute: '{value} perccel ezelőtt',
    messageTimestampFormat: 'h:mm A',
    messageSending: 'Küldés...',
    messageDelivered: 'Kézbesítve',
    messengerChannelDescription: 'Csatlakoztassa Facebook-fiókját a Facebook Messenger használatához.',
    whatsappChannelDescriptionDesktop: 'Kezdje el vagy folytassa a beszélgetését WhatsApp-on? Kattintson az alábbi linkre.',
    whatsappChannelDescriptionMobile: 'Kezdje el vagy folytassa a beszélgetését WhatsApp-on? Kattintson az alábbi linkre.',
    whatsappLinkingError: 'Valami hiba történt a csatlakozás során. Kérem, próbálja újra.',
    notificationSettingsChannelsDescription: 'Más alkalmazásokból vagy szolgáltatásokból is kapcsolatba léphet velünk.',
    notificationSettingsChannelsTitle: 'Egyéb alkalmazások',
    notificationSettingsConnected: 'Csatlakoztatva',
    notificationSettingsConnectedAs: 'Csatlakoztatva, mint {username}',
    prechatCaptureGreetingText: 'Szia 👋\nKezdésként szeretnénk többet tudni rólad:',
    prechatCaptureNameLabel: 'A neved',
    prechatCaptureNamePlaceholder: 'Írd be a neved...',
    prechatCaptureEmailLabel: 'E-mail',
    prechatCaptureEmailPlaceholder: 'name@company.com',
    prechatCaptureConfirmationText: 'Köszönjük! Miben segíthetünk?',
    prechatCaptureMailgunLinkingConfirmation: 'Itt és e-mailben is értesítést kapsz a válaszunkról a következő címen: {email}.',
    sendButtonText: 'Küldés',
    settingsHeaderText: 'Beállítások',
    smsBadRequestError: 'Nem sikerült csatlakozni ehhez a számhoz. Próbálja újra, vagy használjon másik számot.',
    smsCancel: 'Mégse',
    smsChangeNumber: 'Számom módosítása',
    smsChannelDescription: 'Csatlakoztassa SMS-számát a folytatáshoz SMS-ben.',
    smsChannelPendingDescription: 'Ellenőrizze üzeneteit a {number} számon a telefonszám megerősítéséhez.',
    smsContinue: 'Folytatás',
    smsInvalidNumberError: 'A telefonszáma érvénytelen. Kérem, próbálja újra.',
    smsLinkCancelled: 'A {appUserNumber}-hoz való csatlakozás törölve lett.',
    smsLinkPending: 'Függőben',
    smsPingChannelError: 'Hiba történt üzenet küldésekor a számra.',
    smsSendText: 'Küldjön SMS-t',
    smsStartTexting: 'Kezdjen SMS-t küldeni',
    smsTooManyRequestsError: 'Nemrégiben kértek csatlakozást ehhez a számhoz. Kérem, próbálja újra {minutes} percen belül.',
    smsTooManyRequestsOneMinuteError: 'Nemrégiben kértek csatlakozást ehhez a számhoz. Kérem, próbálja újra 1 percen belül.',
    smsUnhandledError: 'Valami hiba történt. Kérem, próbálja újra.',
    tapToRetry: 'Az üzenet nem lett kézbesítve. Nyomja meg az Entert az újrapróbálkozáshoz.',
    tapToRetryForm: 'Az űrlap nem lett benyújtva. Kattintson bárhova az űrlapon az újrapróbálkozáshoz.',
    telegramChannelDescription: 'Csatlakoztassa Telegram-fiókját a folytatáshoz Telegram-on.',
    unsupportedMessageType: 'Nem támogatott üzenet típus.',
    unsupportedActionType: 'Nem támogatott művelet típus.',
    linkError: 'Hiba történt a hivatkozás generálása során ehhez a csatornához. Kérem, próbálja újra.',
    viberChannelDescription: 'Csatlakoztassa Viber-fiókját a folytatáshoz Viber-en.',
    viberChannelDescriptionMobile: 'Csatlakoztassa Viber fiókját, hogy értesítést kapjon, amikor választ kap, és folytassa a beszélgetést Viber-en. Az indításhoz telepítse a Viber alkalmazást, és kattintson a Csatlakozás gombra.',
    viberQRCodeError: 'Hiba történt a Viber QR kódjának lekérése során. Kérem, próbálja újra.',
    wechatChannelDescription: 'Csatlakoztassa WeChat fiókját, hogy értesítést kapjon, amikor választ kap, és folytassa a beszélgetést WeChat-en. Az indításhoz szkennelje be ezt a QR kódot a WeChat alkalmazással.',
    wechatChannelDescriptionMobile: 'Csatlakoztassa WeChat fiókját, hogy értesítést kapjon, amikor választ kap, és folytassa a beszélgetést WeChat-en. Az indításhoz mentse el ezt a QR kódot, és töltse fel a <a href="weixin://dl/scan">QR kód olvasóval</a>.',
    wechatQRCodeError: 'Hiba történt a WeChat QR kódjának lekérése során. Kérem, próbálja újra.',
    fileTooLargeError: 'A maximális fájlméret határát túllépte ({size})',
    shareLocation: 'Helymegosztás',
    uploadDocument: 'Dokumentum feltöltése',
    uploadInvalidError: 'Érvénytelen fájl',
    fileTypeError: 'Nem támogatott fájltípus',
    formErrorInvalidEmail: 'Érvénytelen e-mail',
    formErrorNoLongerThan: 'Nem tartalmazhat több mint ({characters}) karaktert',
    formErrorNoShorterThan: 'Legalább ({characters}) karakterből kell állnia',
    formErrorUnknown: 'Ez nem tűnik teljesen jónak',
    formFieldSelectPlaceholderFallback: 'Válasszon egyet...',
    uploadPhoto: 'Kép feltöltése',
    uploadVirusError: 'Vírust észleltek a fájlban, és el lett utasítva',
    shoutoutText: 'Indítson egy beszélgetést',
    cardClickText: 'Kiválasztva'
};
export { Hungarian };
